<template>
  <div :class="($route.path === '/checkout')? 'col-12 p-4 mt-3 card':'col p-4'">
    <loading
      :active.sync="paymentGatewayLoading"
      :can-cancel="false"
      :is-full-page="true"
      :opacity=1
      loader="dots"
    >
      <div class="lds-ring">
        <div></div>
        <div>
          <img
            src="@/assets/loader/payment.gif"
            alt="Payment Loader"
          >
        </div>
        <div></div>
        <div></div>
      </div>
    </loading>
    <stripe-card-list-template
      @cardSelected="selectedCard = $event"
      @paymentConfirmation="paymentConfirmation"
      v-if="!addNewCard &&
                               ($route.path === '/checkout'?orderSuccess:true)"
    >
    </stripe-card-list-template>
    <div
      class="form-check"
      v-if="showAddAddressForm"
    >
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="defaultCheck1"
        v-model="addNewCard"
        @change="toggleAddCard"
      >
      <label
        class="form-check-label"
        for="defaultCheck1"
        id="checkout-payment-add-newcard"
      >
        Add New Card
      </label>
    </div>
    <div
      class="form-check mb-3"
      v-if="addNewCard"
    >
      <input
        type="checkbox"
        id="checkoutCheck"
        class="form-check-input"
        @change="(showAddAddressForm === true)?
        'showAddAddressForm = false':
        'showAddAddressForm = true'"
        v-model="showAddAddressForm"
      >
      <label
        class="form-check-label"
        for="checkoutCheck"
        v-if="$route.path === '/checkout'"
        id="checkout-payment-billing-address"
      >
        Billing Address Same as Shipping Address.
      </label>
      <label
        class="form-check-label"
        for="checkoutCheck"
        v-else
        id="checkout-payment-edit-billing-address"
      >
        Edit Billing Address
      </label>
    </div>
    <address-form
      v-if="!showAddAddressForm"
      @cancel="showAddAddressForm = true"
      @submitSuccess="addOrUpdateAddress($event)"
      :address="selectedBillingAddress"
    >
    </address-form>
    <stripe-vue-payment-card
      :settings="{
                                labels: {
                                    cardNumber: 'Card number',
                                    month: 'Month',
                                    year: 'Year',
                                    cardHolder: 'Cardholder name',
                                    button: 'pay'
                                },
                                placeholders: {
                                    cardNumber: '',
                                    month: '',
                                    year: '',
                                    cardHolder: '',
                                    cvv: ''
                                },
                                showBank: true,
                                showPaymentSystem: true
                              }"
      :loading="cardPay"
      @card-submit="createToken($event)"
      v-if="showAddNewCard && showAddAddressForm"
    >
    </stripe-vue-payment-card>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapGetters } from 'vuex'
import { orderApi } from '@/services/ApiServices/orderApi'
import StripeVuePaymentCard from '@/components/pages/paymentGateway/stripe/widgets/StripeVuePaymentCard'
import AddressForm from '@/components/shared/forms/AddressForm'
import StripeCardListTemplate from '@/components/pages/paymentGateway/stripe/widgets/StripeCardListTemplate'
import { customerApi } from '@/services/ApiServices/customerApi'

// get all logos file from card-info plugin to use it further
export default {
	name: 'stripe-payment-gateway',
	data () {
		return {
			paymentGatewayLoading: false,
			card: {
				number: '',
				cvc: '',
				exp: '',
				address_city: '',
				address_country: '',
				address_line1: '',
				address_line2: '',
				address_state: '',
				address_zip: ''
			},
			stripePublishableKey: 'pk_test_p4Q2brdQpfqHGoJUBPRJSbvk',
			stripeCheck: false,
			selectedCard: {},
			showAddNewCard: false,
			showAddAddressForm: true,
			addNewCard: false,
			loading: false,
			billingAddress: true, // Same as shipping address
			selectedBillingAddress: {},
			systemSettings: {},
			billingAddressData: Object,
			cardPay: '',
			loadingPay: ''
		}
	},
	components: {
		Loading,
		StripeVuePaymentCard,
		AddressForm,
		StripeCardListTemplate
	},
	computed: {
		...mapGetters('user', ['getSelectedAddressId', 'getSelectedAddress', 'getOrderData']),
		...mapGetters('siteData', ['getPaymentGatewayId'])
	},
	beforeMount () {
		this.loading = true
		if (this.$route.path === '/checkout') {
			this.selectedBillingAddress = this.getSelectedAddress
			// const payMode = 'CARD';
			// orderApi.orderCharge(payMode)
			//   .then((res) => {
			//     this.loading = false;
			//
			//   })
			//   .catch((error) => {
			//     $('#collapse-summary')
			//       .collapse('show');
			//     $('#collapse-payment')
			//       .collapse('hide');
			//
			//   });
		} else {
			customerApi.getAddresses()
				.then((res) => {
					this.loading = false
					this.selectedBillingAddress = res.data[0]
				})
				.catch((e) => {

				})
		}
	},
	methods: {
		paymentConfirmation (card) {
			this.paymentGatewayLoading = true
			let total = 0
			const orderProducts = this.getOrderData.cartProductDetails
			if (orderProducts && orderProducts.length > 0) {
				orderProducts.forEach((product) => {
					total += product.subtotal
				})
			}
			let cardId
			if (this.selectedCard && this.selectedCard.card_id) {
				cardId = this.selectedCard.card_id
			} else {
				cardId = card
			}
			this.cardPay = orderApi.orderCharge('CARD', cardId)
				.then(() => {
					setTimeout(() => {
						this.paymentGatewayLoading = false
						this.$router.push({
							path: '/order-success',
							query: {
								order_number: this.getOrderData.order_number,
								payment_mode: 'card'
							}
						})
					}, 7000)
				})
		},
		toggleAddCard () {
			if (this.addNewCard === true) {
				this.selectedCard = {}
				this.showAddNewCard = true
			} else if (this.addNewCard === false) {
				this.showAddNewCard = false
			}
		},
		addOrUpdateAddress (billingData) {
			this.showAddAddressForm = true
			// if (this.$route.path === '/checkout') {
			this.selectedBillingAddress = billingData
			// } else {
			//   this.selectedBillingAddress = billingData;
			// }
		},
		validate () {
			this.errors = []
			let valid = true
			if (!this.card.number) {
				valid = false
				this.errors.push('Card Number is required')
			}
			if (!this.card.cvc) {
				valid = false
				this.errors.push('CVC is required')
			}
			if (!this.card.exp) {
				valid = false
				this.errors.push('Expiration date is required')
			}
			if (valid) {
				this.createToken()
			}
		},
		createToken (cardInfo) {
			this.selectedCard = {}
			// if (this.$route.path === '/checkout') {
			//   this.selectedBillingAddress = this.billingAddressData.phoneNo ?
			//     this.billingAddressData : this.getSelectedAddress;
			// }
			const billingAddress = this.selectedBillingAddress
			const cardData = {
				number: cardInfo.number,
				exp_month: cardInfo.month,
				exp_year: cardInfo.year,
				cvc: cardInfo.cvv,
				address_city: billingAddress.place,
				address_country: billingAddress.country,
				address_line1: billingAddress.addressLine1,
				address_line2: billingAddress.addressLine2,
				address_state: billingAddress.state,
				address_zip: billingAddress.pinCode
			}

			this.stripeCheck = true
			window.Stripe.setPublishableKey(this.stripePublishableKey)
			window.Stripe.createToken(cardData, (status, response) => {
				if (response.error) {
					this.stripeCheck = false
					this.errors.push(response.error.message)
					// eslint-disable-next-line
        } else {
					const payload = {
						token: response.id,
						address_city: billingAddress.place,
						address_country: billingAddress.country,
						address_line1: billingAddress.addressLine1,
						address_line2: billingAddress.addressLine2,
						address_state: billingAddress.state,
						address_zip: billingAddress.pinCode
					}
					this.cardPay = orderApi.addPaymentCard(payload)
						.then((res) => {
							if (this.$route.path === '/checkout') {
								this.paymentConfirmation(res.data.card_id)
							} else {
								this.addNewCard = false
								this.toggleAddCard()
								this.$root.$emit('newPaymentCardAdded')
							}
						})
				}
			})
		}
	}
}
</script>
